import { Component, SyntheticEvent } from 'react';
export { PureComponent } from 'react';

// why the hell it doesn't work as in C#?
export type ComponentEventHandler = (sender: Component) => void;
export type ComponentEventHandler1<TArg1> = (sender: Component, arg1: TArg1) => void;
export type ComponentEventHandler2<TArg1, TArg2> = (sender: Component, arg1: TArg1, arg2: TArg2) => void;
export type ComponentEventHandler3<TArg1, TArg2, TArg3> = (sender: Component, arg1: TArg1, arg2: TArg2, arg3: TArg3) => void;
export type ComponentEventHandler4<TArg1, TArg2, TArg3, TArg4> = (sender: Component, arg1: TArg1, arg2: TArg2, arg3: TArg3, arg4: TArg4) => void;


export type ReactEventHandler<TEvent = SyntheticEvent<unknown>> = (event: TEvent) => void;
export type ReactEventHandler1<TArg1, TEvent = SyntheticEvent<unknown>> = (arg1: TArg1, event: TEvent) => void;
export type ReactEventHandler2<TArg1, TArg2, TEvent = SyntheticEvent<unknown>> = (arg1: TArg1, arg2: TArg2, event: TEvent) => void;
export type ReactEventHandler3<TArg1, TArg2, TArg3, TEvent = SyntheticEvent<unknown>> = (arg1: TArg1, arg2: TArg2, arg3: TArg3, event: TEvent) => void;


import { entities } from 'typed/api';

import { DispatchProps, ComponentDecorator, connect as originalConnect } from 'typed/utils/redux';

import { WithRouterProps } from 'react-router';

interface PageProps extends WithRouterProps { }
interface SessionProps { session: entities.Session; };
export interface ConnectedProps extends DispatchProps, SessionProps { }

import { State } from 'store';

// quite many components need to know who current user is, 
// and session should remain unchanged during application lifetime, 
// so we can save some lines by including it to every connect'ed component without unknown additional unnecessary updates
// and it should be faster than dedicated higher-level component, since there won't be additional new wrapper class per every component which needs session
// also plenty of components extract some values from react-router provided props - `params` and `location` - so let's also allow passing them to unknown component
export function connect<TStoreProps, TOwnProps>(mapStateToProps: (state: State, ownProps?: TOwnProps & PageProps) => TStoreProps): ComponentDecorator<TStoreProps & SessionProps & ConnectedProps, TOwnProps> {
    return originalConnect<TStoreProps & SessionProps, void, TOwnProps>((state, ownProps) => ({
        session: state.app.session as entities.Session,
        ...(mapStateToProps(state, ownProps as TOwnProps & PageProps) as TStoreProps)
    }), null, null, {}) as ComponentDecorator<TStoreProps & SessionProps & ConnectedProps, TOwnProps>
}
